@if (date()) {
    <span [id]="uid" [title]="relativeTime()">{{ date() | date: 'MM/dd/yyyy h:mm a' }}</span>
    <sh-tooltip [label]="relativeTime()" [target]="uid" placement="top" variation="short"></sh-tooltip>
}
